import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SpecificationVersion } from '../../../app-model/specification-version';
import { ApiProxyService } from '../../shared/services/api-proxy.service';
import { View } from '../model/view';
import { ConfigService } from 'app/app-services/config.service';

@Injectable()
export class ViewService {
  constructor(private apiProxy: ApiProxyService, private configService: ConfigService) { }

  getView(id: number): Observable<View> {
    return this.apiProxy.get(this.configService.apiUrl + 'view/' + id);
  }

  getViews(): Observable<View[]> {
    return this.apiProxy.get(this.configService.apiUrl + 'view').pipe(map((v: View[]) => v.map(viewToMap => this.mapToView(viewToMap))));
  }

  addView(view: View): Observable<View> {
    return this.apiProxy.post(this.configService.apiUrl + 'view', view).pipe(map((v: View) => this.mapToView(v)));
  }

  updateView(view: View): Observable<View> {
    return this.apiProxy.put(this.configService.apiUrl + 'view/' + view.id, view).pipe(map((v: View) => this.mapToView(v)));
  }

  deleteView(view: View): Observable<View> {
    return this.apiProxy.delete(this.configService.apiUrl + 'view/' + view.id).pipe(map((v: View) => this.mapToView(v)));
  }

  addSpecificationVersionToView(view: View, specificationVersion: SpecificationVersion): Observable<SpecificationVersion> {
    return this.apiProxy.post(this.configService.apiUrl + 'view/' + view.id + '/specificationVersion', specificationVersion);
  }

  deleteSpecificationVersionFromView(view: View, specificationVersion: SpecificationVersion): Observable<SpecificationVersion> {
    return this.apiProxy.delete(this.configService.apiUrl + 'view/' + view.id + '/specificationVersion/' + specificationVersion.id);
  }

  mapToView(viewResponse: View): View {
    const view = new View();
    view.updateFrom(viewResponse);
    return view;
  }
}
